<template>
  <div class="block_wrap">

    <div class="line">
      <div class="input_wrap">
        <fg-input
          v-model="upd_user.name"
          type="text"
          :label="translate('user.name')"
          :placeholder="translate('user.name')"
          :readonly="true"
        />
      </div>

      <div class="input_wrap main_name">
        <fg-input
          v-model="upd_user.username"
          type="text"
          :label="translate('user.login')"
          :placeholder="translate('user.login')"
          :readonly="true"
        />
      </div>

    </div>

    <div class="line">
      <div class="input_wrap">
        <fg-input
          v-model="upd_user.email"
          type="email"
          label="Email"
          placeholder="Email"
          :readonly="true"
        />
      </div>

      <div class="input_wrap">
        <fg-input
          autocomplete="sdfgsdfgsfhsdfgsdfh"
          v-model="upd_user.phone"
          :type="'tel'"
          :label="translate('user.phone')"
          @keydown="restrict_chars($event)"
          :placeholder="translate('user.phone')"
          :name="'asdgasdfasgd'"
          :readonly="true"
        />
      </div>

    </div>

    <div class="line">
        <div class="input_wrap">
            <fg-input
                v-model="upd_user.client.name"
                :type="'text'"
                :label="translate('user.my_company')"
                :placeholder="translate('user.my_company')"
                :readonly="true"
            />
        </div>

    </div>

  </div>
</template>
<script>

export default {
  name: 'UserMainInfo',
  props: ['main_info'],

  data () {
    return {
      upd_user: {},
      active_user: true
    }
  },
  computed:{
    changes(){
      let main_info = Object.assign({}, this.main_info)
      let upd_user = Object.assign({}, this.upd_user)

      delete(main_info.ts_update)
      delete(upd_user.ts_update)

      return JSON.stringify(main_info) !== JSON.stringify(upd_user)
    },
    title_filter(){
      return this.active_user ? 'user.active' : 'user.blocked'
    },
    clients_list(){
      let list = []
      for (let item of Object.entries(this.client_ids)) {
        list.push({label: item[1], id: +item[0]})
      }
      return list
    },
    check_client_id(){
      return this.main_info.client_id !== null
    }
  },
  created() {
    this.upd_user = {...this.main_info}

    if (this.upd_user.client_id === ''){
      this.upd_user.client_id = null
    }

    this.active_user = this.upd_user.active === 1
  },
  watch:{
    active_user(){
      this.upd_user.active = this.active_user ? 1 : 0
    },
    main_info(){
      this.upd_user = {...this.main_info}
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .line{
      display: flex;
      justify-content: space-between;
      text-align: left;
      &.new_group{
        margin-bottom: 10px;
        .filter{
          display: contents;
        }
      }
      .input_wrap{
        width: 100%;
        margin: 0 5px;
      }

      .button_wrap{
        width: 100%;
        text-align: right;
      }
    }
    .update_password{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 15px;
      .form-group{
        width: 100%;
        margin: 0 5px;
        .btn{
          height: 40px;
          width: 100%;
          margin: 0;
        }
      }
    }
  }


</style>
